import { render, staticRenderFns } from "./UtxoRowInput.vue?vue&type=template&id=048aa8c2&scoped=true&"
import script from "./UtxoRowInput.vue?vue&type=script&lang=ts&"
export * from "./UtxoRowInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048aa8c2",
  null
  
)

export default component.exports